import React, { useEffect, useState } from "react";
import "./NoticePage.css"; // 引入样式文件
import common from "../../public/common";
import { getCookieNew } from "../../public/utils";
import { getMethod } from "../../server/index";
import moment from "moment";
const home = () => {
  const [businessData, setBusinessData] = useState("");
  const accountData =  localStorage.getItem("accountInfo")?JSON.parse(localStorage.getItem("accountInfo")):{};
  useEffect(() => {
    if (getCookieNew("businessId")) {
      console.log(accountData)
      getMethod(
        `${common.eurekaUrlDic}/auth/no-auth/business-switch/get?business_id=${accountData.business_id}`
      ).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          setBusinessData(res.data.data || "");
        }
      });
    }
  }, []);
  return businessData != "" ? (
    <div className="notice-container">
      <div className="notice-content">
        <div className="notice-title">
          关于SCS系统升级及单号规则按时间区分的重要通知
        </div>
        <div className="notice-greeting">尊敬的供应商伙伴：</div>
        <div className="notice-body">
          <p>您好！</p>
          <p>
            感谢您长期以来对我司的信任与支持。为提升运营效率与服务品质，我司将于近期陆续完成系统升级整合。现将涉及单号格式的重要变更通知如下，敬请知悉。
          </p>
          <p>
            为确保系统平稳过渡与数据准确，我司将以
            <strong>【{businessData.switch_date||'-'}】</strong>
            为分界线，对订单编号规则进行区分管理，具体如下：
          </p>
          <div className="notice-section">
            <h3>1. 新旧单号规则明细：</h3>
            <ul>
              <li>
                <strong>【{businessData.switch_date||'-'}（含）之前】</strong>{" "}
                的历史订单，其单号将统一增加{" "}
                <span className="highlight">【-{businessData.business_suffix||'-'}】</span> 后缀。
              </li>
              <li>
                <strong>【自{businessData.switch_date||'-'}之后】</strong>{" "}
                生成的所有新订单，将保持原有逻辑，不带任何后缀。
              </li>
            </ul>
            <div className="notice-table">
              <table>
                <thead>
                  <tr>
                    <th>单据类型</th>
                    <th>{businessData.switch_date||'-'}（含）之前</th>
                    <th>{businessData.switch_date||'-'}之后</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>订单编号</td>
                    <td>CG2510170001 → CG2510170001-{businessData.business_suffix||'-'}</td>
                    <td>CG2511230001</td>
                  </tr>
                  <tr>
                    <td>发货单号</td>
                    <td>FH25102900043 → FH25102900043-{businessData.business_suffix||'-'}</td>
                    <td>FH251112500001</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="notice-section">
            <h3>2. 对您操作的关键影响与要求：</h3>
            <ul>
              <li>
                自本通知生效之日起，您在进行<strong>发货信息导入</strong>时，
                <strong>
                  必须根据订单列表里展示的单号（有无后缀）填写导入模板，若单号格式填写错误，系统将无法识别，可能导致您的发货数据提交失败。
                </strong>
              </li>
            </ul>
          </div>
          <div className="notice-apology">
            对于升级期间给您带来的不便，我们深表歉意，并衷心感谢您的理解与配合！
          </div>
          <div className="notice-ending">
            <div style={{ marginLeft: "20px" }}>顺祝商祺！</div>
            <div className="notice-signature">
              <div>{businessData.business_name||'-'}</div>
              <div className="notice-date-right">{moment().format('YYYY-MM-DD')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
   <div></div>
  );
};

export default home;



// WEBPACK FOOTER //
// ./src/pages/home/index.jsx